import { Injectable } from "@angular/core";
import { Device } from '@ionic-native/device/ngx';
import { PlatformDetails } from "@root/modules/common/models/platform-details";
import { Platform } from '@ionic/angular';
@Injectable()
export class CoreService {
  loader: any;
  alert: any;

  private _platform_details: PlatformDetails;

  constructor( 
    private platform: Platform, 
    private device: Device) { }

  // initailizePlatformDetails() {
  //   return {
  //     isDesktop:  this.platform.is('desktop'),
  //     isMobile: this.platform.is('mobile'),
  //     isMobileBrowser: this.platform.is('mobileweb'),
  //     isMobileApp: this.platform.is('cordova'),
  //     isAndroidApp: this.platform.is('android'),
  //     isIosApp: this.platform.is('ios'),
  //     isIPad: this.platform.is('ipad')
  //   }
  // }
  initailizeCorePlatformDetails() {
    this._platform_details = {
      isDesktop: this.platform.is('desktop'),
      isMobile: this.platform.is('mobile'),
      isMobileBrowser: this.platform.is('mobileweb'),
      isMobileApp: this.platform.is('cordova'),
      isAndroidApp: this.platform.is('android'),
      isIosApp: this.platform.is('ios'),
      isIPad: this.platform.is('ipad')
    }
  }

  getCorePlatformDetails() {
    return this._platform_details;
  }

  initailizeDeviceDetails() {
    return {
      cordovaVersion: this.device.cordova,
      deviceModel: this.device.model,
      osName: this.device.platform,
      uuid: this.device.uuid,
      osVersion: this.device.version,
      deviceManufacturer: this.device.manufacturer,
      deviceSerialId: this.device.serial
    }
  }


}
